module.exports = __webpack_public_path__ + "static/images/tab-upcoming.924402109e1e144a4ca6301db7b5e83d.svg";